import { render } from "./PaginationLinks.vue?vue&type=template&id=6031d107"
import script from "./PaginationLinks.vue?vue&type=script&lang=js"
export * from "./PaginationLinks.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PaginationLinks.vue"]])

export default __exports__